import { CommentType } from 'src/components/postComments'
import { medias } from 'src/utils/constants'

export const getTitles = (i18n: { t: (key: string) => string }) => {
  return {
    [CommentType.AUDIO]: {},
    [CommentType.DOCUMENT]: {
      title: i18n.t('input_publish.button_send_pdf')
    },
    [CommentType.IMAGE]: {
      title: i18n.t('input_publish.button_send_image')
    }
  }
}

export const getDropZoneprops = (i18n: { t: (key: string) => string }) => {
  return {
    [CommentType.AUDIO]: {},
    [CommentType.DOCUMENT]: {
      buttonLabel: i18n.t('input_publish.button_send_pdf'),
      text: i18n.t('input_publish.text_drag_and_drop_image'),
      disclaimer: i18n.t('input_publish.message_pdf_format'),
      errorMessages: {
        invalidFileType: i18n.t('input_publish.message_pdf_format'),
        invalidFileSize: i18n.t('input_publish.message_pdf_format')
      },
      acceptedTypes: medias.pdf,
      maxSize: 20971520 // 20MB
    },
    [CommentType.IMAGE]: {
      buttonLabel: i18n.t('input_publish.button_send_image'),
      text: i18n.t('input_publish.text_drag_and_drop_image'),
      disclaimer: i18n.t('input_publish.message_image_format'),
      errorMessages: {
        invalidFileType: i18n.t('input_publish.error.invalid_image_format')
      },
      acceptedTypes: medias.image
    }
  }
}
